import configDefault from "./config-default";

const config = {
	...configDefault,
	code: 'pf',
	appClassName: 'TODO',
	favicon: '/clubplanetfitness-favicon.png',
	title: "Je m'inscris | Planete Fitness",
	companyName: "Planete Fitness",
	website: 'https://www.club-planetefitness.com/',
	notifyChannel: 'vel-pf',
	htmlCustomCSS: "planetefitness.scss",
	header: {
		title: "Je m'abonne",
		logo: "/clubplanetfitness.png",
		urlLogo: "https://www.planetefitness.com/"
	},
	footer: {
		logo: "/clubplanetfitness--white.png",
		// TODO cgv: {
		// TODO 	link: 'https://TODO',
		// TODO 	text: 'CGV'
		// TODO }
	},
	navigation: {
		reinitAuto: false,
		allowChangeClub: true,
	},
  promoCode: {
    label: "Avez-vous un code promo ?",
    placeholder: "VOTRE CODE ICI",
    confirmLabel: "Appliquer",
    verifyingLabel: "En cours de vérification"
  },
	payByCard: "STRIPE",
	choice: {
		selectLabel: 'Sélectionner',
		selectedLabel: 'Sélectionné',
		mandatoryLabel: "Obligatoire",
		nameColor: '#252525',
		border: '#EFECEC',
		border_selected: 'lightgray',
		background: 'white',
		footerBg: '#EFECEC',
		footerBg_selected: '#f7f7f7',
		checkboxSelected: '#252525'
	},
	errorCode: {
		...configDefault.errorCode,
		"api.error.sale.contact-invalid-data":"Veuillez essayer avec une autre adresse mail ou contacter le club directement.",
		default: "Une erreur est survenue avec Resamania2",
	},
	sign : {
		title: 'Signature du contrat',
		placeholder: "Code reçu par SMS",
		explain: "Entrer ici le code reçu par SMS pour signer le contrat",
		resendCodeLabel: "Renvoyer le code",
		badCodeLabel: "Code incorrect",
		signLabel: "Valider la signature",
	},
	payment: {
		loadingLabel: "Vérification en cours",
		informationLabel: "Informations de paiement",
		resumeLabel: "Total à payer par CB: ",
		payLabel: "Payer ",
		errorLabel: "Nous avons un soucis avec votre paiment.",
		errorTitle: "Une erreur est survenue",
	},
	loadingDefault: "Chargement en cours",
	loadingSmsCodeCheck: 'Vérification du code',
	loadingSmsCodeSend: 'Envoi du SMS',
	loadingTextUserCreation: "Création de votre compte",
	loadingTextCartCreation: "Création de votre panier",
	loadingTextAddressCheck: "Vérification de votre adresse",
	loadingTextOffersLoad: "Chargement des offres",
	loadingTextPhotoUpdate: "Enregistrement de votre photo",
	plans: {
		...configDefault.plans,
		noPlanFoundTitle: "Aucune formule",
		noPlanFoundTexts : [
			"Nous n'avons trouvé aucune formule pour ce club,",
			"veuillez réessayer plus tard ou changer de club via l'étape 1"
		],
		useImg : 'withText',
		beforeUser: true,
		imageBaseURL: 'https://api.resamania.com',
		title: "JE CHOISIS MA FORMULE",
		// splitCounterAbo: {
		// 	subsText : ["En illimité", "Dès 39€"],
		// 	passText: ['A la séance', "Dès 5€"]
		// },
		incitation: "Je choisis ma formule",
		feesLabel : "Frais d'inscription",
		nofeesLabel: " ",
		autoSubmit: false,
		nextLabel: "Suivant",
	},
	productsLoader : {
		errorTitle: "Une erreur est survenue avec Resamania2",
		errorText: 'Veuillez réessayer plus tard ou avec un autre club',
	},
	options: {
		title: "JE CHOISIS MES OPTIONS",
		message: "",
		nextLabel: "Suivant",
		useImg: "withText",
		imageBaseURL: 'https://api.resamania.com',
	},
	regulars : false,
	recap: {
		title: "Ma sélection",
		myOffer: "Ma formule",
		myCounter: "Mes options et équipements",
		nextLabel: "Je confirme",
		payByCardLabel: "Total à payer par carte",
		payBySepaLabel : "Total prélevé directement",
	},
	sepa : {
		title: "RIB - PRELEVEMENT",
		validateLabel : "J’accepte par la présente les prélèvements automatiques SEPA",
		explain: "Veuillez mettre votre RIB ci-dessous pour valider votre abonnement et signer votre mandat de prélèvement SEPA",
		ownerLabel: "Titulaire du compte",
		ibanLabel: "IBAN",
		bicLabel: "BIC",
		bankLabel: "Nom de la banque",
	},
	contract: {
		title: "Votre contrat",
		signLabel: "Signer le contrat",
	},
	photo: {
		step: "end",
		title: "Votre photo de membre Planète fitness",
		nextLabel: "Suivant",
		explain: "Prenez une photo de vous pour assurer votre accès au club.",
	},
	confirmation: {
		welcomeLabel: "Bienvenue chez",
		text: "Votre adhésion a bien été prise en compte, vous recevrez un e-mail de confirmation sous peu.",
		restartLabel: "Recommencer",
	},
	steps: {
		display: {
			showShortNames: true,
		},
		clubSelect: {
			noAddress: false,
			showMap: "Masquer la carte",
			hideMap: "Voir la carte",
			title: 'JE CHOISIS MON CLUB',
			nextLabel: "Suivant",
			withMap: false,
			searchable:false,
			sameLine: false,
			autoSelect: true,
			//showOnly: 3,
			// confirm: {
			// 	txt: "En cochant cette case, je confirme souhaiter m’inscrire au club sélectionné, comme étant mon club d’entrainement principal."
			// }
		},
		userForm: {
			...configDefault.steps.userForm,
			nextLabel: "Suivant",
			genderLabel: 'Civilité',
			gender_F: "Mme",
			gender_M: "M.",
			firstnameLabel: 'Prénom',
			lastnameLabel: "Nom",
			emailLabel: 'Adresse e-mail',
			phoneLabel: "Nº de téléphone portable",
			phoneExplain: "Utilisé pour la signature du contrat et du mandat SEPA",
			birthdateLabel: "Date de naissance",
			addressLabel: "Adresse",
			backLabel: "Retour",
			noClub: true,
			noGender: false,
			noAddress: false,
			noBirthdate: false,
			title: "MES COORDONNÉES",
			optins: {
				acceptLegal: {
					...configDefault.steps.userForm.optins.acceptLegal,
					text: "J’ai lu et j'accepte les conditions générales de Planete Fitness",
					href: 'https://www.planetefitness.com/_files/ugd/6719f4_44a4d6862f13440cb4c6daa8f4ba7ad2.pdf',
					required: true,
					moreLabel: "Lire les conditions générales"
				},
				acceptNewsletter: {
					...configDefault.steps.userForm.optins.acceptNewsletter,
					text: "Je souhaite recevoir les actualités, informations et conseils de Planete Fitness par mail ou SMS",
				},
				acceptAdvertising: {
					...configDefault.steps.userForm.optins.acceptAdvertising,
					text: "J'accepte de recevoir les offres commerciales personnalisées de Planete Fitness",
				},
				acceptPartner: {
					...configDefault.steps.userForm.optins.acceptPartner,
					text: "J'autorise Planete Fitness à transmettre mes coordonnées à ses partenaires sélectionnés afin de recevoir leurs offres et communications",
				},
			}
		},
	},
	stepsLabels: {
		...configDefault.stepsLabels,
	},
	stepsShortLabels: {
		...configDefault.stepsShortLabels
	},
	rootProperties: {
		'primary': '#AE1D22',
		'primary--dark': 'darken(#AE1D22, 15)',
		'placeholder': '#999999',
		'border': '#3d3d3d',
	},
	htmlStyle: `
		html {
			font-weight: 400;
			font-family: 'Roboto';
		}
	`,
	theme: {
		primary: '#252525',
		stepsDisplay: {
			color: {
				main: '#252525',
				bgFilled: '#252525',
				textFilled: 'white',

				subText: '#252525',
			}
		},
		loader : {
			border: 'black',
			border2: '#EB5A4B'
		},
		fontFamily: "Montserrat, sans-serif",
		buttonPrimary: {
			color: '#252525',
			text: '#fff',
		},
		buttonOther: {
			color: 'black',
			text: '#fff',
		},
		buttonSecondary: {
			color: "black",
			text: '#fff'
		},
		stepHeader: {
			fontWeight: 800,
			fontSize: "1.25rem",
			textTransform: 'uppercase',
			paddingTop:'1rem'
		},
		checkColor: '#6FA888'
	}
};

export default config;
